import OnePageFirstStyleIcon from 'assets/icons/OnePageFirstStyleIcon.svg';
import OnePageSecondStyleIcon from 'assets/icons/OnePageSecondStyleIcon.svg';
import OnePageThirdStyleIcon from 'assets/icons/OnePageThirdStyleIcon.svg';

import { ONE_PAGE_STYLE_OPTIONS } from '../types';

export const ONE_PAGE_STYLE_BUTTONS = [
  { style: ONE_PAGE_STYLE_OPTIONS.SECOND_STYLE, bgImage: OnePageSecondStyleIcon }, // styles are mistaken in code, in design our second style is the first style and vice versa
  { style: ONE_PAGE_STYLE_OPTIONS.FIRST_STYLE, bgImage: OnePageFirstStyleIcon },
  { style: ONE_PAGE_STYLE_OPTIONS.THIRD_STYLE, bgImage: OnePageThirdStyleIcon },
];
